"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteService = void 0;
const service_1 = require("./service");
const news_1 = require("../models/news");
const mapper_1 = require("../utils/mapper");
const profileMapper_1 = require("../utils/profileMapper");
const siteComments_1 = require("../utils/siteComments");
const forum_1 = require("../models/forum");
const SITE_COMMENT_VOTE_MESSAGES = {
    3: 'Комментарий уже скрыт или действие недоступно',
};
const SITE_POLL_VOTE_MESSAGES = {
    3: 'Неверные аргументы или опрос закрыт',
    4: 'Голосование недоступно',
    5: 'Вы уже голосовали',
};
const SITE_COMMENT_MESSAGES = {
    0: 'Комментарий добавлен',
    4: 'Вам запрещено комментировать',
    5: 'Нет текста комментария',
    6: 'Комментирование этой статьи окончено',
    7: 'Нельзя ответить на свёрнутый вами комментарий',
    8: 'Достигнут кармический лимит комментирования',
    9: 'Повторный комментарий',
    10: 'Достигнут часовой лимит комментирования',
    11: 'Достигнут дневной лимит комментирования',
    12: 'Комментарий отправлен на премодерацию',
    13: 'Комментарий отправлен на премодерацию',
    14: 'Комментарий отправлен на премодерацию',
};
class SiteService extends service_1.Service {
    constructor(transport, auth) {
        super(transport, auth);
    }
    /**
     * Get list of articles/news from the "САЙТ" section.
     * Command: "sl" (SITE_LIST) - 27763
     * @param offset Start from this article (pagination), default 0
     * @param limit Number of articles to return, default 30
     * @param tagId Tag/category filter (0 = all categories)
     * @returns Array of mapped Article objects
     */
    async getArticles(offset = 0, limit = 30, tagId = 0) {
        const response = await this.transport.send('sl', [offset, limit, -1, tagId]);
        if (response.status === 0 && Array.isArray(response.data)) {
            const total = typeof response.data[0] === 'number' ? response.data[0] : 0;
            const articles = response.data[1];
            if (Array.isArray(articles)) {
                return {
                    total,
                    articles: articles.map((item) => this.mapArticle(item)),
                };
            }
            return { total, articles: [] };
        }
        return { total: 0, articles: [] };
    }
    parseArticleFlags(raw) {
        return typeof raw[4] === 'number' ? raw[4] : 0;
    }
    mapArticle(raw) {
        // console.log('SITE_LIST_ITEM_RAW:', JSON.stringify(raw));
        return {
            id: raw[0],
            date: mapper_1.PdaMapper.safeIsoDate(raw[1]),
            title: raw[9],
            imageUrl: typeof raw[8] === 'string' ? raw[8] : undefined, // Confirmed: index 8 is URL
            description: typeof raw[10] === 'string' ? raw[10] : '',
            authorId: raw[5],
            authorName: raw[6],
            flags: this.parseArticleFlags(raw),
            commentsCount: typeof raw[7] === 'number' ? raw[7] : 0,
            tags: Array.isArray(raw[12]) ? raw[12].map((t) => t[1]) : []
        };
    }
    /**
     * Get comments for a specific article.
     * Command: "sl" (SITE_LIST)
     * @param articleId Article ID
     * @param offset Start comment index (pagination)
     * @param limit Number of comments to return
     * @returns Array of mapped ArticleComment objects
     */
    async getComments(articleId, offset = 0, limit = 30) {
        const response = await this.transport.send('sl', [offset, limit, articleId, 0]);
        if (response.status === 0 && Array.isArray(response.data)) {
            const comments = response.data[1];
            if (Array.isArray(comments)) {
                return (0, siteComments_1.mapSiteCommentsRaw)(comments);
            }
        }
        return [];
    }
    /**
     * Get advertising banner for site article view.
     * Command: "aa" (GET_ADVERTISING) - 24929
     * Request: [bannerType] — `1` = баннер в статье (Android Q0.q)
     * Response data: [width, height?, imageUrl, …, clickUrl]
     */
    async getAdvertising(bannerType = news_1.SiteAdvertisingBannerType.ARTICLE) {
        const response = await this.transport.send('aa', [bannerType]);
        if (response.status !== 0 || !Array.isArray(response.data)) {
            return null;
        }
        return this.mapAdvertising(response.data);
    }
    mapAdvertising(data) {
        if (!Array.isArray(data) || data.length < 2)
            return null;
        const width = typeof data[0] === 'number' ? data[0] : 0;
        const height = typeof data[1] === 'number' ? data[1] : undefined;
        let imageUrl;
        let clickUrl;
        if (typeof data[2] === 'string') {
            imageUrl = data[2];
            clickUrl = typeof data[4] === 'string'
                ? data[4]
                : (typeof data[3] === 'string' ? data[3] : undefined);
        }
        else {
            const urls = data.filter((item) => typeof item === 'string' && item.length > 0);
            if (urls.length === 0)
                return null;
            imageUrl = urls[0];
            clickUrl = urls.length > 1 ? urls[urls.length - 1] : urls[0];
        }
        if (!imageUrl)
            return null;
        return {
            width,
            height,
            imageUrl,
            clickUrl: clickUrl || imageUrl,
        };
    }
    /**
     * Get a single article with full content and comments.
     * Command: "sa" (SITE_ARTICLE) - 24947
     * @param articleId Article ID
     * @returns Full article content (BBCode) with mapped comments array
     */
    async getArticle(articleId) {
        const response = await this.transport.send('sa', [articleId]);
        if (response.status === 0 && Array.isArray(response.data)) {
            return this.mapFullArticle(response.data);
        }
        return null;
    }
    /**
     * Jump to adjacent article in the site feed by publish time.
     * Command: "sj" (SITE_JUMP) - 27251
     * Request: [next: 0|1, timestamp, category] — Android AbstractC0112a.y / Q0.p
     * Response: [articleId, ...] on success
     * @param timestamp Unix seconds of the current article
     * @param next true = newer article, false = older (Q0.D / Q0.C)
     * @param category Tag filter; -1 = all categories (Android default)
     */
    async jump(timestamp, next, category = -1) {
        const response = await this.transport.send('sj', [next ? 1 : 0, timestamp, category]);
        const status = response.status ?? -1;
        if (status === 0 && Array.isArray(response.data) && typeof response.data[0] === 'number') {
            return {
                ok: true,
                status,
                articleId: response.data[0],
            };
        }
        if (status > 0 && status < 20) {
            return {
                ok: false,
                status,
                message: 'Статья не найдена',
            };
        }
        this.checkError(response, 'sj');
        return { ok: false, status, message: 'Ошибка перехода' };
    }
    mapFullArticle(raw) {
        return {
            id: raw[0],
            date: mapper_1.PdaMapper.safeIsoDate(raw[1]),
            title: raw[9],
            imageUrl: typeof raw[8] === 'string' ? raw[8] : undefined,
            description: '',
            authorId: raw[5],
            authorName: raw[6],
            flags: this.parseArticleFlags(raw),
            commentsCount: typeof raw[7] === 'number' ? raw[7] : 0,
            content: raw[10],
            tags: Array.isArray(raw[12]) ? raw[12].map((t) => t[1]) : [],
            comments: Array.isArray(raw[13]) ? (0, siteComments_1.mapSiteCommentsRaw)(raw[13]) : [],
            attachments: Array.isArray(raw[11]) ? raw[11].map((a) => this.mapAttachment(a)) : [],
            polls: this.mapSitePolls(raw[14]),
        };
    }
    /** Опросы статьи — индекс [14] sa (ForPDA ArticleParser fields[16]). */
    mapSitePolls(raw) {
        if (!Array.isArray(raw) || raw.length === 0)
            return [];
        const polls = [];
        for (const item of raw) {
            if (!Array.isArray(item) || item.length < 5)
                continue;
            const optionsRaw = item[4];
            if (!Array.isArray(optionsRaw))
                continue;
            const options = [];
            for (const opt of optionsRaw) {
                if (!Array.isArray(opt) || opt.length < 3)
                    continue;
                options.push({
                    id: opt[0],
                    text: typeof opt[1] === 'string' ? opt[1] : String(opt[1] ?? ''),
                    votes: typeof opt[2] === 'number' ? opt[2] : 0,
                });
            }
            polls.push({
                id: item[0],
                title: typeof item[1] === 'string' ? item[1] : '',
                flags: typeof item[2] === 'number' ? item[2] : 0,
                totalVotes: typeof item[3] === 'number' ? item[3] : 0,
                options,
            });
        }
        return polls;
    }
    mapAttachment(raw) {
        return {
            id: raw[0],
            url: raw[1],
            width: raw[2],
            height: raw[3],
            description: raw[4],
            fullUrl: raw[5]
        };
    }
    /**
     * Add a comment or reply to a site article.
     * Command: "sc" (SITE_COMMENT) - 25459
     * Request: [articleId, parentCommentId, text] — parentCommentId 0 for root comment.
     */
    async addComment(articleId, parentCommentId, text) {
        const response = await this.transport.send('sc', [articleId, parentCommentId, text]);
        const status = response.status ?? -1;
        const ok = status === 0 || status === 12 || status === 13 || status === 14;
        if (!ok && status > 0 && status < 20) {
            return {
                ok: false,
                status,
                message: SITE_COMMENT_MESSAGES[status] ?? 'Ошибка при добавлении комментария',
            };
        }
        if (!ok) {
            this.checkError(response, 'sc');
        }
        return {
            ok: true,
            status,
            message: SITE_COMMENT_MESSAGES[status] ?? 'Комментарий добавлен',
        };
    }
    /**
     * Vote in a site article poll.
     * Command: "so" (28531) — Android AbstractC0112a.A / Q0.g (НЕ forum "fv").
     * Request: [pollId, optionId, ...] — плоский документ, id вариантов (без вложенного массива).
     */
    async votePoll(pollId, optionIds) {
        if (!optionIds.length) {
            return { ok: false, status: -1, message: 'Выберите вариант ответа' };
        }
        const response = await this.transport.send('so', [pollId, ...optionIds]);
        const status = response.status ?? -1;
        if (status === 0) {
            return { ok: true, status, message: 'Голос засчитан' };
        }
        if (status > 0 && status < 20) {
            return {
                ok: false,
                status,
                message: SITE_POLL_VOTE_MESSAGES[status] ?? 'Не удалось проголосовать',
            };
        }
        this.checkError(response, 'so');
        return { ok: false, status, message: 'Не удалось проголосовать' };
    }
    /**
     * Vote comment karma (plus).
     * Command: "sk" (SITE_COMMENT_VOTE) - 27507 — vote `1`.
     */
    async likeComment(articleId, commentId) {
        return this.voteComment(articleId, commentId, 1);
    }
    /**
     * Hide article comment (moderator). Same `sk` as karma — vote `-1` (Q0.java «Скрыть»).
     */
    async hideComment(articleId, commentId) {
        return this.voteComment(articleId, commentId, -1);
    }
    /**
     * Vote comment karma (plus / hide).
     * Command: "sk" (SITE_COMMENT_VOTE) - 27507
     * Request: [articleId, commentId, vote] — vote: 1 = plus, -1 = hide (not minus karma).
     */
    async voteComment(articleId, commentId, vote) {
        const response = await this.transport.send('sk', [articleId, commentId, vote]);
        const status = response.status ?? -1;
        if (status === 0) {
            return {
                ok: true,
                status,
                message: vote === -1 ? 'Комментарий скрыт' : 'Карма комментария повышена',
            };
        }
        if (status === 3) {
            return {
                ok: false,
                status,
                message: vote === -1
                    ? 'Нельзя скрыть этот комментарий (уже скрыт или поставлен плюс в карму)'
                    : (SITE_COMMENT_VOTE_MESSAGES[3] ?? 'Нельзя изменить карму этого комментария'),
            };
        }
        if (status > 0 && status < 20) {
            return {
                ok: false,
                status,
                message: SITE_COMMENT_VOTE_MESSAGES[status] ?? 'Не удалось выполнить действие',
            };
        }
        this.checkError(response, 'sk');
        return { ok: false, status, message: 'Не удалось выполнить действие' };
    }
    /**
     * Report a site article comment.
     * Command: "ta" — type 1 = article comment (Q0.java / API_Reference).
     */
    async sendCommentReport(commentId, text) {
        const response = await this.transport.send('ta', [1, commentId, text]);
        let status = forum_1.ReportStatus.UNKNOWN_ERROR;
        let message = 'Неизвестная ошибка';
        const rawStatus = response.status;
        if (rawStatus === 0) {
            status = forum_1.ReportStatus.SUCCESS;
            message = 'Жалоба успешно отправлена';
        }
        else if (rawStatus === 2) {
            status = forum_1.ReportStatus.LIMIT_ERROR;
            message = 'Ошибка ограничений (жалоба на свой комментарий, повторная жалоба или нет прав)';
        }
        else if (rawStatus === 3) {
            status = forum_1.ReportStatus.NOT_FOUND;
            message = 'Комментарий не найден';
        }
        else if (rawStatus === 4) {
            status = forum_1.ReportStatus.TOO_SHORT;
            message = 'Текст жалобы слишком короткий';
        }
        else {
            this.checkError(response, 'ta');
        }
        return { status, message, _raw: response.data };
    }
    /**
     * Synchronize site navigation menu.
     * Command: "sm" (MEMBER_SYNC) - 28019
     * @param version Last sync version (timestamp). Use 0 for full sync.
     */
    async getMenuSync(version = 0) {
        const response = await this.transport.send('sm', [version]);
        const data = response.data;
        return {
            version: data[0],
            items: (data[1] || []).map(item => ({
                id: item[0],
                tagId: item[1],
                path: item[2],
                title: item[3],
                isHidden: item[4] !== 0,
                parentId: item[5]
            }))
        };
    }
    /**
     * Get user's browsing history.
     * Command: "mh" (MEMBER_HISTORY) - 26733
     * @param offset Start offset for pagination
     * @param limit Number of items per page (default 30)
     */
    async getHistory(offset = 0, limit = 30) {
        const response = await this.transport.send('mh', [offset, limit]);
        const mapped = profileMapper_1.ProfileMapper.mapHistory(response.data);
        return {
            totalCount: mapped.count,
            items: mapped.topics.map((topic) => ({
                topicId: topic.id,
                title: topic.title,
                description: topic.subtitle,
                bitmask: topic.bitmask,
                replies: topic.replies,
                lastPostTimestamp: topic.lastPostTs,
                lastPostUserId: topic.lastUserId,
                lastPostUserName: topic.lastUserName,
                visitTimestamp: topic.visitTs,
            })),
        };
    }
    /**
     * Get site rules.
     * Command: "fn" (FORUM_RULES)
     * Response: [ReqID, 0, Title, Content]
     */
    async getRules() {
        // We use 'fn' without args based on cli test: "node cli.js fn" -> [id, "fn"]
        // Sending [0] might be interpreted as requesting announcement #0 which might be empty/invalid
        const response = await this.transport.send('fn', []);
        // CLI output: [5000, 0, "Правила форума", "[b]..."]
        // So data[2] is title, data[3] is content.
        if (response.status === 0 && Array.isArray(response.data)) {
            // response.data[1] is status 0
            // response.data[0] is Title
            // response.data[1] is Content
            return response.data[1] || '';
        }
        return '';
    }
}
exports.SiteService = SiteService;
